<script>
    import { createEventDispatcher } from 'svelte';

    import DatabaseItem from './DatabaseItem.svelte';
    import IconLink from "./icons/IconLink.svelte";
    export let databases;

    const dispatch = createEventDispatcher();

    function handleClick(event, database) {
        event.preventDefault();
        console.log("database: ",database);
        dispatch('openDialog', {database}); // Dispatch a 'click' event
    }


</script>

    <div id="resultsList"
         class="w-100 database-list">
        {#each databases as database (database.id)}
            <DatabaseItem {database}
                          on:click={(event) => handleClick(event, database)}
            />
        {/each}
    </div>

<style>
</style>
